import CRUDService from './crud-service';

export interface PresignedUploadURL {
  url: string;
}

export default new CRUDService<PresignedUploadURL>({
  baseUrl: '/v1/presigned-upload-url',
  useJWT: true,
});
